export default __webpack_public_path__ + "static/media/2t.c518fa6d.jpg";